<template>
  <div class="que-container">
    <QuestionTitle :data="data" />
    <div class="q-content">
      <div class="q-scroll">
        <QuestionRadio
          v-if="data.que_type === 0"
          :data="data"
          @change="bindChange"
          :theme="theme"
        ></QuestionRadio>
        <QuestionCheckbox
          v-if="data.que_type == 1"
          :data="data"
          @change="bindChange"
          :theme="theme"
        >
        </QuestionCheckbox>
        <QA
          v-if="data.que_type == 2"
          :data="data"
          @change="bindChange"
          :theme="theme"
        ></QA>
        <QuestionRuler
          class="question-ruler"
          v-if="data.que_type == 5"
          :data="data"
          @change="bindChange"
          :theme="theme"
        />
        <QuestionTime
          v-if="data.que_type == 6"
          :data="data"
          @change="bindChange"
          :theme="theme"
        />
        <QuestionImagePreview
          v-if="data.que_type == 7"
          :step="data.step"
          :data="data"
          @change="bindChange"
          :theme="theme"
        />
        <div
          class="select-tips"
          :class="{ 'select-tips-bottom': data.que_type == 5 }"
          v-if="data.selectTip + ''"
        >
          <template v-if="Array.isArray(data.selectTip)">
            <div v-for="(item, index) in data.selectTip" :key="index">{{
              item
            }}</div>
          </template>
          <div v-else>{{ data.selectTip }}</div>
        </div>

        <div
          class="question-tips"
          v-if="data.que_introduce_type == 1 && data.que_introduce"
        >
          {{ data.que_introduce }}
        </div>
        <div class="options-tips" v-if="questionTips.length">
          <span
            class="o-tips-item"
            v-for="(item, index) in questionTips"
            :key="index"
            v-html="item.desc"
          ></span>
        </div>
      </div>
    </div>
    <div
      class="question-tips-image"
      v-if="data.que_introduce_type == 2 && data.que_introduce"
    >
      <img class="image" :src="data.que_introduce" alt="" />
    </div>
  </div>
</template>
<script>
import QuestionTitle from './question/q-title.vue'
import QuestionRadio from './radio.vue'
import QuestionCheckbox from './checkbox.vue'
import QuestionRuler from './ruler/index.vue'
import QuestionTime from './time/index.vue'
import QA from './qa/qa.vue'
import QuestionImagePreview from './question-image-preview.vue'
export default {
  components: {
    QuestionTitle,
    QuestionRadio,
    QuestionCheckbox,
    QA,
    QuestionRuler,
    QuestionTime,
    QuestionImagePreview
  },
  props: {
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    questionTips() {
      let arr = []
      if (Array.isArray(this.data.options)) {
        this.data.options.map((item) => {
          if (item.introduce) {
            arr.push({
              desc: item.introduce
            })
          }
        })
      }
      arr = arr.map((item, index) => {
        if (index < arr.length - 1) {
          item.desc = item.desc + '；'
        }
        return item
      })
      return arr
    }
  },
  methods: {
    bindChange(value) {
      this.$emit('change', value)
    }
  }
}
</script>
<style lang="scss" scoped>
.que-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.options-tips {
  color: rgba(105, 115, 135, 1);
  font-size: 12px;
  font-family: PingFangSC-Semibold, PingFang SC;
  color: #697387;
  line-height: 20px;
  margin-top: 28px;

  .o-tips-item {
    display: inline;
  }
}

.question-tips {
  text-align: center;
  margin-top: 20px;
  padding: 0px 16px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #697387;
  line-height: 20px;

  .bold {
    font-weight: 600;
  }
}

.select-tips {
  text-align: center;
  margin-top: 28px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #697387;
  line-height: 20px;
}

.select-tips-bottom {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 150px;
}

.q-content {
  flex: 1;
  flex-shrink: 0;
  overflow: hidden;

  .q-scroll {
    box-sizing: border-box;
    height: 100%;
    padding-top: 28px;
    overflow-y: scroll;
  }
}

.question-tips-image {
  z-index: -1;
  width: 309px;
  left: 50%;
  transform: translate(-50%, 0%);
  bottom: 0px;
  position: absolute;

  .image {
    width: 100%;
  }
}

.question-ruler {
  position: absolute;
  width: 100%;
  left: 0;
  top: 50%;
  transform: translate(0%, -50%);
}
</style>
